module.exports = __webpack_public_path__ + "static/img/0-home4.2fc31ee5.png";